import ApiService from "../../api.service";
import appConfig from "../../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const IntakeSettingService = {

  dataSourceConfig(url, params) {
    return ApiService.createDataSource(url, params);
  },

  async saveIntakeVarietySizeCombination(payload) {
    var url = `api/Save_IntakeVarietySizeCombination`;
    return await ApiService.post(url, payload);
  },

};

export { IntakeSettingService };
